import styled from 'styled-components';

export const CaptchaRoot = styled.div`
  &.active {
    display: flex;
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 1;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.45);
  }
`;
